import { Component, Input, ViewChild } from '@angular/core';
import { AppGridComponent } from '@common/components/app-grid/app-grid.component';

@Component({
    selector: 'app-vessel-permit-grid',
    templateUrl: './vessel-permit-grid.component.html',
    styleUrls: ['./vessel-permit-grid.component.scss']
})
export class VesselPermitGridComponent {
    @Input() query;
    @Input() selection = [];
    @ViewChild(AppGridComponent) public appGrid: AppGridComponent;

    isRestricted(statusId: string, showToolTip = false) {
        return showToolTip ? statusId === 'DT' ? 'Detained Vessel' : 'Alert Vessel' : ['DT', 'BN'].includes(statusId);
    }
}
